import { Spin, Typography } from "antd";
import moment from "moment";
import { useEffect } from "react";
import { Socket } from "socket.io-client";
import { useGetOneTransaction } from "../../../../api/currency";
import PaymentStatus from "../../../../types/paymentStatus.type";
import useResponsive from "../../../../utils/hooks/useResponsive";
import { formatNumber } from "../../../../utils/list.utils";
import StatusForm from "./status-form";
import TextContent from "./text-content";

const FormCryptoDeposits = ({
  orderId,
  socket,
  data,
  isLoading,
  refetch,
}: {
  orderId: string;
  socket: Socket<any, any>;
  data: any;
  isLoading: boolean;
  refetch: any;
}) => {
  const { isTablet } = useResponsive();

  const reasonStatus = () => {
    switch (data?.data?.data?.status) {
      case PaymentStatus.REJECTED:
        return data?.data?.data?.reason || "N/A";
      case PaymentStatus.PROCESSING:
        return data?.data?.data?.reason || "";
      default:
        return (
          data?.data?.data?.reason ||
          `Crypto has been deposited into your wallet. See your portfolio for details.`
        );
    }
  };

  useEffect(() => {
    if (!orderId) return;
    const handleDetailWalletUpdated = () => {
      refetch();
    };
    socket.on(
      `user.walletOrder.${Number(orderId)}.updated`,
      handleDetailWalletUpdated
    );

    return () => {
      socket.off(
        `user.walletOrder.${Number(orderId)}.updated`,
        handleDetailWalletUpdated
      );
    };
  }, [socket, orderId, refetch]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            minHeight: "438px",
          }}
        >
          <Spin size="large" className="custom-spin" />
        </div>
      ) : (
        <div className="form-history">
          <StatusForm
            status={data?.data?.data?.status || ""}
            content={reasonStatus()}
          />
          <div className="modal-balance">
            <div className="value-balance">
              <Typography style={{ fontSize: 16, color: "white" }}>
                Quantity
              </Typography>
              <Typography.Text className={"text-gradient"}>
                {formatNumber(
                  data?.data?.data?.amount || 0,
                  data?.data?.data?.decimals
                )}{" "}
                <Typography.Text
                  className="text-gradient"
                  style={{
                    fontSize: isTablet ? "20px" : "24px",
                  }}
                >
                  {data?.data?.data?.currency}
                </Typography.Text>
              </Typography.Text>
            </div>
          </div>
          <div className="form-history-content">
            <TextContent
              label="Currency"
              value={data?.data?.data?.currency || "N/A"}
            />
            <TextContent
              label="Chain Type"
              value={data?.data?.data?.chainType}
            />
            <TextContent
              label={
                data?.data?.data?.type === "ONCHAIN_DEPOSIT"
                  ? "Address"
                  : "Remitter"
              }
              value={
                data?.data?.data?.type === "ONCHAIN_DEPOSIT"
                  ? data?.data?.data?.address
                  : data?.data?.data?.remitterFullName
              }
              canCopy={data?.data?.data?.type === "ONCHAIN_DEPOSIT"}
            />
          </div>
          <div className="form-history-content border-top">
            <TextContent
              label="Time"
              value={moment(data?.data?.data?.createdAt).format(
                "HH:mm:ss DD/MM/YYYY"
              )}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FormCryptoDeposits;
